import { render, staticRenderFns } from "./DialogHome.vue?vue&type=template&id=22b9977a&scoped=true"
import script from "./DialogHome.vue?vue&type=script&lang=js"
export * from "./DialogHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b9977a",
  null
  
)

export default component.exports